/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
// import axios from "axios";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Table,
  UncontrolledTooltip,
  Spinner,
  Pagination,
  PaginationItem,
  PaginationLink,
  FormGroup,
  //Modal,
} from "reactstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

import "moment-duration-format";

// actions
import {
  resetAutomaticMessage,
  resetAutomaticMessages,
  resetError,
  getAutomaticMessages,
  //editAutomaticMessage,
} from "../../store/automaticmessages/actions";

//import Switch from "react-switch";

import { useDispatch, useSelector } from "react-redux";

//i18n
import { withTranslation } from "react-i18next";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { renderPagination } from "../../Libs/CrudUtils/crudUtils";

const AutomaticMessages = ({ t }) => {
  const dispatch = useDispatch();

  const qtdDefault = 7;

  const {
    dataAutomaticMessage,
    dataAutomaticMessageEditCreate,
    loadingAutomaticMessage,
    //loadingAutomaticMessageEditCreate,
    errorAutomaticMessage,
    successAutomaticMessage,
  } = useSelector((state) => state.AutomaticMessage);

  const [page, setPage] = useState(1);

  //Uncomment this to put the active/desactive in the read of Automatic messages
  /*const [modal, setModal] = useState(false);
  const [automaticMessageId, setAutomaticMessageId] = useState("");
  const [automaticMessageName, setAutomaticMessageName] = useState("");
  const [active, setActive] = useState();
  const [status, setStatus] = useState();*/

  const [nameFilter, setNameFilter] = useState("");

  const [notFound, setNotFound] = useState(false);

  const showToast = (type, message) => {
    toastr[type](message);
  };
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () => {
      dispatch(resetAutomaticMessage());
      successAutomaticMessage &&
        dispatch(resetAutomaticMessages()) &&
        handleFilter();
    },
  };

  const handleFilter = (name) => {
    setNameFilter(name);
    setPage(1);
    dispatch(getAutomaticMessages(1, qtdDefault, name));
  };
  //Uncomment this to put the active/desactive in the read of Automatic messages
  /*const handleActive = () => {
    dispatch(editAutomaticMessage(automaticMessageId, active));
  };

  const toggleModal = () => {
   setModal(!modal);
  };

  const setAutomaticMessageIdName = (automaticMessage) => {
    setAutomaticMessageId(automaticMessage.id);
    setAutomaticMessageName(automaticMessage.name);
  };*/

  const handlePage = (value) => {
    setPage(value);
    dispatch(getAutomaticMessages(value, qtdDefault, nameFilter));
  };

  const handlePreviousPage = () => {
    if (page > 1) {
      handlePage(page - 1);
    }
  };

  const handleNextPage = () => {
    if (dataAutomaticMessage?.paging) {
      if (page < dataAutomaticMessage.paging.length) {
        handlePage(page + 1);
      }
    }
  };

  useEffect(() => {
    if (dataAutomaticMessageEditCreate?.message && successAutomaticMessage) {
      showToast("success", t(dataAutomaticMessageEditCreate.message));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successAutomaticMessage]);

  useEffect(() => {
    if (errorAutomaticMessage && typeof errorAutomaticMessage === "object") {
      errorAutomaticMessage.map(
        //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
        (error) =>
          error.value !== "AutomaticMessages not found" &&
          showToast("error", t(error.value))
      );
      dispatch(resetError());
    } else {
      if (errorAutomaticMessage) {
        showToast("error", t(errorAutomaticMessage));
        dispatch(resetError());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorAutomaticMessage]);

  useEffect(() => {
    if (dataAutomaticMessage !== null) {
      setNotFound(false);
    } else {
      setNotFound(true);
    }
  }, [dataAutomaticMessage]);

  useEffect(() => {
    handleFilter();
  }, []); 

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            mainPath="/dashboard"
            path="/automatic-messages"
            title={t("Dashboard")}
            breadcrumbItem={t("Automatic Messages")}
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody className="card-height">
                  <AvForm
                    onValidSubmit={(event, values) => {
                      handleFilter(values.name);
                    }}
                  >
                    <Row>
                      <Col xs="12" md="4" lg="3" xl="auto" className="mb-3">
                        <FormGroup>
                          <AvField
                            label={t("Name")}
                            id="name"
                            name="name"
                            type="text"
                            className="form-control"
                            placeholder={t("Name") + "..."}
                            validate={{
                              pattern: {
                                value: "/^[A-Za-z0-9 áàâãéèêíïóôõöúç]*$/i", // only letters, numbers and space
                                errorMessage: t(
                                  "Name must be composed only with letter and numbers"
                                ),
                              },
                              minLength: {
                                value: 3,
                                errorMessage: t("Min 3 characters"),
                              },
                              maxLength: {
                                value: 60,
                                errorMessage: t("Max 60 characters"),
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col
                        xs="12"
                        md="4"
                        lg="auto"
                        className="mt-auto mb-3 filter-create-btn"
                      >
                        <Button
                          type="submit"
                          color="primary"
                          className="waves-effect waves-light w-100 mb-3 mr-3"
                        >
                          <i className="mdi mdi-feature-search-outline mr-1"></i>
                          {t("Search")}
                        </Button>
                      </Col>
                      {/* //Uncomment this if client can add automatic message */}
                      {/* <Col
                        xs="12"
                        md="4"
                        lg="auto"
                        className="mt-auto mb-3 ml-auto filter-create-btn"
                      >
                        <div className="text-sm-right mb-3" id="new-AutomaticMessage">
                          <Link to={`/automatic-message`}>
                            <Button
                              type="button"
                              color="success"
                              className={"waves-effect waves-light w-100 mr-2 "}
                            
                            >
                              <i className="mdi mdi-plus mr-1"></i>
                              {t("Add Automatic Message")}
                            </Button>
                          </Link>
                        </div>
                      </Col> */}
                    </Row>
                  </AvForm>

                  <div className="table-responsive">
                    <PerfectScrollbar>
                      <Table className="table table-centered table-nowrap">
                        <thead className="thead-light">
                          <tr>
                            <th>{t("Name")}</th>
                            <th className="w-100">{t("Description")}</th>
                            <th className="text-center">{t("Action")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loadingAutomaticMessage ? (
                            <tr>
                              <td colSpan="20" align="center">
                                <Spinner
                                  size="sm"
                                  animation="border"
                                  style={{
                                    marginTop: "40px",
                                    height: "50px",
                                    width: "50px",
                                  }}
                                />
                              </td>
                            </tr>
                          ) : notFound ? (
                            <tr>
                              <td colSpan="20" align="center">
                                {t("Click search to show the records")}
                              </td>
                            </tr>
                          ) : dataAutomaticMessage?.messages?.length > 0 ? (
                            dataAutomaticMessage.messages.map(
                              (automaticMessage, key) => (
                                <tr key={key}>
                                  <td className="column-text-overflow-30">
                                    {t(automaticMessage.name)}
                                  </td>
                                  <td className="column-text-overflow-10 w-100">
                                    {automaticMessage.description}
                                  </td>
                                  <td>
                                    <div className="d-inline-flex">
                                      <Link
                                        to={`/automatic-message/${automaticMessage.id}`}
                                        className="text-primary text-center mr-2"
                                        id="edit"
                                      >
                                        <i
                                          className="mdi mdi-pencil font-size-18 px-2"
                                          id={`edittooltip${key}`}
                                        ></i>
                                        <UncontrolledTooltip
                                          placement="auto"
                                          target={`edittooltip${key}`}
                                        >
                                          {t("Edit")}
                                        </UncontrolledTooltip>
                                      </Link>
                                      {/* Uncomment this (Switch and Modal) if active/desactive go back to the read page of automatic messages */}
                                      {/* <Switch
                                        className="d-flex align-self-center"
                                        onColor="#5673E6"
                                        offColor="#2E3548"
                                        onHandleColor="#2E3548"
                                        offHandleColor="#32394E"
                                        checked={automaticMessage.active}
                                        handleDiameter={10}
                                        width={28}
                                        height={16}
                                        checkedIcon={false}
                                        uncheckedIcon={false}
                                        onChange={() => {
                                          setAutomaticMessageIdName(
                                            automaticMessage
                                          );
                                          toggleModal();
                                          setStatus(
                                            automaticMessage.active
                                              ? t("deactivate")
                                              : t("activate")
                                          );
                                          setActive({
                                            active: !automaticMessage.active,
                                          });
                                        }}
                                      />
                                      <div className="d-flex align-self-center ml-2">
                                        {automaticMessage.active
                                          ? t("Active")
                                          : t("Inactive")}
                                      </div>*/}
                                    </div>
                                  </td>
                                </tr>
                              )
                            )
                          ) : (
                            <tr>
                              <td colSpan="20" align="center">
                                {t("No matching records found")}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                      {/* Uncomment this (Switch and Modal) if active/desactive go back to the read page of automatic messages */}
                      {/* <Modal
                        isOpen={modal || loadingAutomaticMessageEditCreate}
                      >
                        <div className="modal-body font-size-18 text-center">
                          {`${t("Do you want to")} ${status}`}
                          <strong> {automaticMessageName}</strong>?
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            onClick={toggleModal}
                            className="btn btn-danger waves-effect"
                            data-dismiss="modal"
                            style={{ backgroundColor: "#f14646" }}
                          >
                            {t("No")}
                          </button>
                          {loadingAutomaticMessageEditCreate ? (
                            <button
                              type="button"
                              className="btn btn-secondary waves-effect waves-light"
                              disabled
                            >
                              <Spinner size="sm" animation="border" />
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-secondary waves-effect waves-light"
                              onClick={() => {
                                toggleModal();
                                if (automaticMessageId) handleActive();
                              }}
                            >
                              {t("Yes")}
                            </button>
                          )}
                        </div>
                      </Modal>*/}
                    </PerfectScrollbar>
                  </div>
                  {renderPagination(
                    page,
                    dataAutomaticMessage?.paging,
                    handlePreviousPage,
                    handlePage,
                    handleNextPage
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(AutomaticMessages);
